export const REGEX = {
  username: /^[a-z0-9_-]{5,20}$/,
  passwordLength: /^.{8,16}$/,
  name: /^[가-힣ㄱ-ㅎㅏ-ㅣA-Za-z\s]+$/,
  phone: /^010\d{8}$/,
  emailDomain:
    /^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/,
};

export type AgreeState = {
  privacy: boolean;
  service: boolean;
  location: boolean;
  info: boolean;
  marketing: boolean;
  info_consent: boolean;
};

export type TermItem = {
  required: boolean;
  name: string;
  state: keyof AgreeState;
  url: string;
};

export const termList: TermItem[] = [
  {
    required: true,
    name: '개인정보 처리방침',
    state: 'privacy',
    url: '/terms/privacy',
  },
  {
    required: true,
    name: '땅집고 옥션 서비스 이용약관',
    state: 'service',
    url: '/terms/service',
  },
  {
    required: true,
    name: '위치기반서비스 이용약관',
    state: 'location',
    url: '/terms/location',
  },
  {
    required: false,
    name: '정보 푸시 알림 수신',
    state: 'info',
    url: '/terms/push',
  },
  {
    required: false,
    name: '마케팅 수신 동의',
    state: 'marketing',
    url: '/terms/marketing',
  },
  {
    required: false,
    name: '제3자 정보 제공 동의',
    state: 'info_consent',
    url: '/terms/info',
  },
];

export const feedbackMessages = {
  username: {
    default: '5~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.',
    required: '아이디는 필수 입력값입니다.',
    duplicate: '이미 사용 중인 아이디입니다.',
    available: '사용 가능한 아이디입니다.',
  },
  password: {
    default:
      '8~16자의 영문, 숫자, 특수문자를 조합하여 입력해주세요.\n(사용 가능한 특수문자 ! ? @ # $ % * &)',
    required: '비밀번호는 필수 입력값입니다.',
  },
  passwordConfirm: {
    default: '',
    required: '비밀번호 확인은 필수 입력값입니다.',
    mismatch: '비밀번호가 일치하지 않습니다. 확인 후 재입력해 주세요.',
    success: '비밀번호가 일치합니다.',
  },
  name: {
    default: '',
    required: '이름은 필수 입력값입니다.',
    invalid: '이름은 한글 또는 영문으로만 입력해주세요.',
  },
  phone: {
    default: '',
    required: '휴대폰 번호는 필수 입력값입니다.',
    invalid:
      '잘못된 휴대폰 번호 형식입니다. 휴대폰 번호를 정확하게 입력해 주세요.',
    duplicate: '이미 등록된 휴대폰 번호입니다.',
  },
  phoneCode: {
    default: '',
    required: '인증번호를 입력해 주세요.',
    mismatch: '인증번호가 일치하지 않습니다.',
    timeout: '인증 시간이 초과되었습니다. 재발송 후 다시 시도해 주세요.',
  },
};
